import { render, staticRenderFns } from "./BetItems.vue?vue&type=template&id=2d8b60c9"
import script from "./BetItems.vue?vue&type=script&lang=ts"
export * from "./BetItems.vue?vue&type=script&lang=ts"
import style0 from "./BetItems.vue?vue&type=style&index=0&id=2d8b60c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports